import { SvgIcon, type SvgIconProps } from "@mui/material";

// Figma's Material glyphs (nodes 3345:39676 / 3345:39689). The DS `add` is a
// thin outline, and CovIcon pins its <svg> to the size step inline (16px), so
// neither the 20px bold plus nor the 14px Visit can be expressed with CovIcon.
const iconSx = {
  color: "var(--alias-icon-on-white-primary, #000)",
  flexShrink: 0,
};

export const AddCollectionIcon = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 20 20"
    aria-hidden
    {...props}
    sx={{
      ...iconSx,
      width: "var(--spacing20, 20px)",
      height: "var(--spacing20, 20px)",
    }}
  >
    <path d="M16 11.1429H9.14286V18H6.85714V11.1429H0V8.85714H6.85714V2H9.14286V8.85714H16V11.1429Z" />
  </SvgIcon>
);

export const VisitIcon = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 14 14"
    aria-hidden
    {...props}
    sx={{
      ...iconSx,
      width: "var(--spacing14, 14px)",
      height: "var(--spacing14, 14px)",
    }}
  >
    <path d="M2.91667 13.9998C2.14338 13.9989 1.40201 13.6914 0.855213 13.1446C0.308416 12.5978 0.000849216 11.8565 0 11.0832V4.08333C0.000849216 3.31006 0.308416 2.5687 0.855213 2.02192C1.40201 1.47513 2.14338 1.16757 2.91667 1.16673H4.95833V1.18131C5.12298 1.21492 5.27097 1.30436 5.37727 1.43452C5.48356 1.56467 5.54163 1.72754 5.54167 1.89559C5.5417 2.06368 5.48365 2.22662 5.37735 2.35683C5.27106 2.48705 5.12303 2.57654 4.95833 2.61015V2.62503H2.91667C2.53001 2.62541 2.15931 2.77918 1.8859 3.05258C1.61249 3.32598 1.45872 3.69668 1.45833 4.08333V11.0832C1.45872 11.4698 1.61249 11.8405 1.8859 12.1139C2.15931 12.3873 2.53001 12.5411 2.91667 12.5415H9.91667C10.3033 12.5411 10.674 12.3873 10.9474 12.1139C11.2208 11.8405 11.3746 11.4698 11.375 11.0832V9.04156C11.375 8.84818 11.4518 8.66272 11.5886 8.52597C11.7253 8.38923 11.9108 8.31241 12.1042 8.31241C12.2976 8.31241 12.483 8.38923 12.6198 8.52597C12.7565 8.66272 12.8333 8.84818 12.8333 9.04156V11.0832C12.8324 11.8564 12.5248 12.5977 11.978 13.1445C11.4313 13.6913 10.6899 13.9989 9.91667 13.9998H2.91667ZM5.67409 8.35237C5.53739 8.21563 5.4606 8.0302 5.4606 7.83686C5.4606 7.64351 5.53739 7.45808 5.67409 7.32135L11.5366 1.45897H8.3125C8.11911 1.45897 7.93365 1.38215 7.7969 1.24541C7.66016 1.10866 7.58333 0.923201 7.58333 0.729818C7.58333 0.536435 7.66016 0.350973 7.7969 0.21423C7.93365 0.077488 8.11911 0.000666922 8.3125 0.000666922H13.2708C13.4642 0.000666922 13.6497 0.077488 13.7864 0.21423C13.9232 0.350973 14 0.536435 14 0.729818V5.68805C14 5.88143 13.9232 6.06689 13.7864 6.20364C13.6497 6.34038 13.4642 6.4172 13.2708 6.4172C13.0774 6.4172 12.892 6.34038 12.7552 6.20364C12.6185 6.06689 12.5417 5.88143 12.5417 5.68805V2.51653L6.70541 8.35266C6.6377 8.42039 6.55731 8.47411 6.46883 8.51077C6.38036 8.54742 6.28552 8.56629 6.18975 8.56629C6.09397 8.56629 5.99914 8.54742 5.91066 8.51077C5.82219 8.47411 5.7418 8.4201 5.67409 8.35237Z" />
  </SvgIcon>
);
